export const reviewTracking = [
  {
    id: 1,
    backend_value: 'in_internal_review',
    name: 'Experience/Subject *',
    description:
      '* Quests considered to be in Experience/Subject are those currently assigned to a quest manager with Experience and/or Subject not checked as complete.',
    sort: 0,
    in_internal_review: true,
    in_copy_edit: false,
    value: 1,
    label: 'Experience/Subject *'
  },
  {
    id: 2,
    backend_value: 'in_copy_edit',
    name: 'Copy Edit *',
    description:
      '* Quests considered to be in Copy Edit are those that have Experience and Subject checked as complete with only Copy Edit remaining.',
    sort: 1,
    in_internal_review: false,
    in_copy_edit: true,
    value: 2,
    label: 'Copy Edit *'
  }
]



// WEBPACK FOOTER //
// ./src/constants/reviewtracking.js